import { ThemeName } from "./theme-names";

export class ByThemeRegistry<T> {
    constructor(private _default: T) {}

    private _registry: Partial<Record<string, T>> = {};

    forCasino777(override: T): this {
        this._registry[ThemeName.Casino777.forClient] = override;
        return this;
    }

    forCasino888(override: T): this {
        this._registry[ThemeName.Casino888.forClient] = override;
        return this;
    }

    forCip(override: T): this {
        this._registry[ThemeName.Casino888Cip.forClient] = override;
        return this;
    }

    forWsopCip(override: T): this {
        this._registry[ThemeName.WsopCip.forClient] = override;
        return this;
    }

    forCis(override: T): this {
        this._registry[ThemeName.Casino888Cis.forClient] = override;
        return this;
    }

    forHarrahs(override: T): this {
        this._registry[ThemeName.Harrahs.forClient] = override;
        return this;
    }

    forWsop(override: T): this {
        this._registry[ThemeName.Wsop.forClient] = override;
        return this;
    }

    forBallysDover(override: T): this {
        this._registry[ThemeName.BallysDover.forClient] = override;
        return this;
    }

    forDelawarePark(override: T): this {
        this._registry[ThemeName.Delawarepark.forClient] = override;
        return this;
    }

    forHarrington(override: T): this {
        this._registry[ThemeName.Harrington.forClient] = override;
        return this;
    }

    forSI(override: T): this {
        this._registry[ThemeName.SI.forClient] = override;
        return this;
    }

    forSICis(override: T): this {
        this._registry[ThemeName.SICis.forClient] = override;
        return this;
    }

    forMrGreen(override: T): this {
        this._registry[ThemeName.MrGreen.forClient] = override;
        return this;
    }

    forMrGreenCis(override: T): this {
        this._registry[ThemeName.MrGreenCis.forClient] = override;
        return this;
    }

    getRegistryItem = (themeName: ThemeName) => {
        return this._registry[themeName.forClient] ? this._registry[themeName.forClient] : this._default;
    }
}
